(function () {
  'use strict';

  // "Calf Width" → "preselect_calf_width"
  function toParamKey(optionName) {
    return 'preselect_' + optionName.toLowerCase().replace(/[\s-]+/g, '_');
  }

  // Returns [{key, value}] for every currently-checked variant radio on the page.
  function getCheckedOptions() {
    var seen = {};
    var result = [];
    document.querySelectorAll('[data-variant-input]:checked').forEach(function (radio) {
      var key = toParamKey(radio.name);
      if (!seen[key]) {
        seen[key] = true;
        result.push({ key: key, value: radio.value });
      }
    });
    return result;
  }

  // Rewrites hrefs inside .related-products and .style-options to carry
  // the current size / calf-width selection as preselect_* params.
  function rewriteOutboundLinks() {
    var opts = getCheckedOptions();
    document.querySelectorAll('.related-products a[href], .style-options a[href]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        // Drop any stale preselect_* params from a previous selection
        Array.from(url.searchParams.keys())
          .filter(function (k) { return k.indexOf('preselect_') === 0; })
          .forEach(function (k) { url.searchParams.delete(k); });
        // Write the current selection
        opts.forEach(function (o) { url.searchParams.set(o.key, o.value); });
        link.href = url.toString();
      } catch (_) { /* skip non-parseable hrefs */ }
    });
  }

  // On the destination page: reads preselect_* params, clicks matching radios,
  // then strips the params from the URL so the browser shows a clean address.
  function resolvePreselectParams() {
    var params = new URLSearchParams(window.location.search);
    var hadPreselect = false;

    // Group all radios by option name for fast lookup
    var radiosByName = {};
    document.querySelectorAll('[data-variant-input]').forEach(function (r) {
      if (!radiosByName[r.name]) radiosByName[r.name] = [];
      radiosByName[r.name].push(r);
    });

    Object.keys(radiosByName).forEach(function (optName) {
      var key = toParamKey(optName);
      if (!params.has(key)) return;
      hadPreselect = true;
      var targetVal = params.get(key);
      var match = radiosByName[optName].filter(function (r) { return r.value === targetVal; })[0];
      // Click only if found and not already in the right state
      if (match && !match.checked) {
        match.click();
      }
      // Silent fallback: if no matching radio, Shopify's default stays selected
    });

    if (hadPreselect) {
      var cleaned = new URLSearchParams(window.location.search);
      Array.from(cleaned.keys())
        .filter(function (k) { return k.indexOf('preselect_') === 0; })
        .forEach(function (k) { cleaned.delete(k); });
      var qs = cleaned.toString();
      history.replaceState(
        null, '',
        window.location.pathname + (qs ? '?' + qs : '') + window.location.hash
      );
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    // setTimeout(0) ensures Impulse's own DOMContentLoaded variant handlers
    // (registered earlier in DOM order via theme.js) have bound before we click.
    setTimeout(function () {
      resolvePreselectParams();
      rewriteOutboundLinks();
    }, 0);

    // Keep outbound link hrefs current whenever the customer changes their selection
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-variant-input]')) {
        rewriteOutboundLinks();
      }
    });
  });
}());
